import { Component, Input } from '@angular/core';

@Component({
  selector: 'inner-spiral',
  templateUrl: './inner-spiral.component.html',
  styleUrls: ['./inner-spiral.component.css']
})
export class InnerSpiralComponent {
  @Input() primaryColor!: string; // Default primary color
  @Input() secondaryColor!: string;
  @Input() thickness!: any;
  @Input() width!: any;

  ngOnInit(){
    this.width = Number(this.width) || 48;   // default to 90 if invalid
    this.thickness = Number(this.thickness) || 3; // default to 4 if invalid
  }
}
